/**
 * A registry for the content module, to hold and access module-wide data. Use LEContent.context or
 * LEContent.getContext() to obtain a reference to this registry.
 *
 * context.KEYS can be used to reuse key values for the registry.
 *
 * Created by eliranm on 17/11/14.
 */
define(function (require) {
    'use strict';

    var LE = require('app');

    var ContentContextController = {};
    LE.module('LEContent', function (LEContent, LE, Backbone, Marionette, $, _) {

        ContentContextController = Marionette.Controller.extend({

            KEYS: {
                contentImportErrorsResponse: 'contentImportErrorsResponse',
                cannedContentImportRunningInBackground: 'cannedContentImportRunningInBackground',
                cannedContentPreviousApplicationRoute: 'cannedContentPreviousApplicationRoute',
                hasContentImportPrivileges: 'hasContentImportPrivileges'
            },

            initialize: function () {
                this.model = new Backbone.Model();
            },

            /**
             * Sets a new entry in the context.
             * @param key The entry key.
             * @param value The entry value.
             */
            set: function (key, value) {
                this.model.set(key, value);
            },

            /**
             * Gets a value from the context.
             * @param key The entry key.
             * @returns {*} The value associated with the key, or falsey value if not exist.
             */
            get: function (key) {
                return this.model.get(key);
            },

            /**
             * Gets a value from the context, converted to a boolean value. Syntactic sugaring on top of
             * <code>get()</code> for predicates and the like.
             * @param key The entry key.
             * @returns {*} The value associated with the key as a boolean value.
             */
            is: function (key) {
                return !!this.get(key);
            },

            /**
             * Removes an entry from the context.
             * @param key The entry key.
             */
            remove: function (key) {
                this.model.unset(key);
            },

            /**
             * Clears all entries from the context.
             */
            clear: function () {
                this.model.clear();
            },

            /**
             * Checks if the context has a specific value.
             * @param key The entry key.
             * @returns <code>true</code> if the context has the value associated with the key, <code>false</code>
             * otherwise.
             */
            has: function (key) {
                return !!this.model.has(key);
            },

            /**
             * Gets a value from the context, and removes its entry.
             * @param key The entry key.
             * @returns {*} The value associated with the key, or falsey value if not exist.
             */
            getAndRemove: function (key) {
                var res = this.get(key);
                this.remove(key);
                return res;
            }

        });
    });

    return ContentContextController;
});